const React = require("react");
const Layout = require("./src/components/Layout.jsx").default;
const eventBus = require("./src/assets/scripts/utils/eventBus.js").default;

exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

exports.onRouteUpdate = ({ location, prevLocation }) => {
  eventBus.dispatch("routeChange", location);
};

exports.shouldUpdateScroll = () => {
  return false;
};
